import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import verticalWhiteArrows from "../../assets/icons/white-vertical-arrows.svg";
import forwardArrows from "../../assets/icons/forward-arrows-icon.svg";
import verticalSpanGroup from "../../assets/icons/span-group-2.gif";
import appSectionImg from "../../assets/images/app-section-img.gif";
import appSectionBG from "../../assets/images/app-section-bg.png";
import bottomSpanLines from "../../assets/icons/span-group.gif";
import exexGroup from "../../assets/icons/white-exes-animated.gif";
import AppButton from "../app-button";
import PlatformBox from "../platform-box";

const sxStyles = {
  mainContainer: {
    backgroundImage: `url(${appSectionBG})`,
    backgroundSize: "cover",
    display: "flex",
    justifyContent: "center",
    flexGrow: 1,
    overflow: "hidden",
    position: "relative",
  },
  content: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: "flex-start",
    justifyContent: "flex-end",
    width: "1440px",
    boxSizing: "border-box",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left",
    paddingTop: { xs: "70px", md: "190px" },
    paddingRight: { xs: "0px", md: "160px" },
  },
  sectionText: {
    color: "white",
    fontSize: { xs: "16px", md: "24px" },
    fontFamily: "IBM Plex Sans",
    fontWeight: "400",
    lineHeight: { xs: "24px", md: "34px" },
    textAlign: "left",
    maxWidth: { xs: "355px", md: "100%" },
    paddingLeft: { xs: "20px", md: 0 },
  },
  p2Title: {
    color: "#FDD925",
    fontFamily: "p22-arts-and-crafts",
    fontSize: { xs: "32px", md: "64px" },
    fontWeight: "700",
    lineHeight: { xs: "33px", md: "65px" },
    marginRight: "13px",
  },
  title: {
    color: "#FDD925",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "36px", md: "64px" },
    fontWeight: "700",
    lineHeight: { xs: "37px", md: "65px" },
    marginRight: "13px",
  },
  secondTitle: {
    color: "#FDD925",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "35px", md: "64px" },
    fontWeight: "700",
    lineHeight: { xs: "35px", md: "65px" },
    marginRight: "13px",
    marginBottom: "32px",
  },
};

const AppSection = () => {
  return (
    <Grid sx={sxStyles.mainContainer}>
      <Grid sx={sxStyles.content}>
        <Box
          sx={{
            marginTop: "143px",
            position: "absolute",
            left: "40px",
            top: "0px",
            display: { xs: "none", md: "block" },
            width: "9px",
            height: "420px",
          }}
        >
          <img
            src={verticalWhiteArrows}
            style={{ width: "9px", height: "420px" }}
          />
        </Box>
        <Box
          sx={{
            width: { xs: "100%", md: "500px" },
            height: "100%",
            background: {
              xs: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${appSectionImg})`,
              md: `url(${appSectionImg})`,
            },
            backgroundPosition: { xs: "left top", md: "center center" },
            backgroundSize: { xs: "cover", md: "cover" },
            position: { xs: "absolute", md: "relative" },
            top: { xs: 0, md: "unset" },
            left: { xs: 0, md: "unset" },
            right: { xs: 0, md: "unset" },
          }}
        />
        <Stack
          sx={{
            position: "relative",
            paddingTop: { xs: "360px", md: "30px" },
            paddingLeft: { xs: "0px", md: "20px" },
          }}
        >
          <Box
            sx={{
              position: "absolute",
              height: "14px",
              width: "56px",
              top: "10px",
              left: "10px",
              display: { xs: "none", md: "block" },
            }}
          >
            <img
              src={forwardArrows}
              style={{ height: "14px", width: "56px" }}
            />
          </Box>
          <Typography sx={sxStyles.sectionText}>
            Colecciona cards, sé parte de la Comunidad y gana premios exclusivos
            de BZRP Social Club.
          </Typography>
          <Grid
            sx={{
              display: "flex",
              flexDirection: "row",
              marginTop: "20px",
              justifyContent: { xs: "center", md: "left" },
            }}
          >
            <Typography sx={sxStyles.p2Title}>DESCARGA</Typography>
            <Typography sx={sxStyles.title}>LA APP Y</Typography>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: { xs: "center", md: "left" },
            }}
          >
            <Typography sx={sxStyles.secondTitle}>COMIENZA A</Typography>
            <Typography sx={sxStyles.p2Title}>JUGAR</Typography>
          </Grid>
          <Box
            sx={{
              paddingLeft: { xs: "12px", md: 0 },
              paddingBottom: { xs: "20px", md: 0 },
            }}
          >
            <PlatformBox />
            {/*<AppButton bgColor={"#FED301"} color={"black"} />*/}
          </Box>
          <Box
            sx={{
              display: { xs: "none", md: "block" },
              height: "157px",
              width: "113px",
              marginLeft: "270px",
            }}
          >
            <img src={bottomSpanLines} style={{}} />
          </Box>
          <Box
            sx={{
              width: "450px",
              height: "90px",
              position: "absolute",
              zIndex: 1,
              left: { xs: "10px", md: "-480px" },
              top: { xs: "75px", md: "250px" },
            }}
          >
            <img src={exexGroup} style={{ width: "450px", height: "80px" }} />
          </Box>
          <img
            src={verticalSpanGroup}
            style={{
              height: "320px",
              width: "50px",
              position: "absolute",
              top: "225px",
              left: "650px",
            }}
          />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default AppSection;
